/**
 * 系统用户接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const brandRemit = {
    // 获取所有品牌汇活动列表信息    
    getMobileBrandRemitList(params) {
        return axios.post('/goods/mobileBrandRemit/getMobileBrandRemitList', qs.stringify(params));
    },
    // 获取所有品牌汇活动商品列表信息    
    getMobileBrandRemitGoodsList(params) {
        return axios.post('/goods/mobileBrandRemit/getMobileBrandRemitGoodsList', qs.stringify(params));
    },
    // 根据品牌汇id获取品牌汇详情信息    
    getBrandRemitDetail(params) {
        return axios.post('/goods/mobileBrandRemit/getMobileBrandRemitDetail', qs.stringify(params));
    },
    //获取购物车可用品牌汇活动信息
    getBucketMeetBrandRemit(params) {
        return axios.post('/goods/mobileBrandRemit/getBucketMeetBrandRemit', qs.stringify(params));
    },
    // 首页获取秒杀时间
    getSeckillEndTime(params) {
        return axios.post('/goods/mobileUser/getSeckillEndTime', qs.stringify(params));
    }
}

export default brandRemit;


// WEBPACK FOOTER //
// ./src/request/api/brandRemit/brandRemit.js